import { useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import { toast } from 'react-toastify';
import { Tooltip } from '@components/ui/tooltip';
import api from '@services/api';

import MyDispositionsDialog from './MyDispositionsDialog';

type Props = {
  executionId: string,
};

const MyDispositionsButton = ({ executionId }:Props) => {
  const [showMyDispositionsDialog, setShowMyDispositionsDialog] = useState(false);
  const [checkingMyDispositions, setCheckingMyDispositions] = useState(false);
  const [myDispositions, setMyDispositions] = useState([]);

  const checkMyDispositions = async () => {
    setCheckingMyDispositions(true);

    try {
      const response = await api.get(`/campaign_execution/${executionId}/my_dispositions`);

      if (response.data.length === 0) {
        toast.info('Você não possui atendimentos aguardando resposta.');
        return;
      }

      setMyDispositions(response.data);
      setShowMyDispositionsDialog(true);
    } catch {
      toast.error('Erro ao verificar se possui atendimentos aguardando resposta.');
    } finally {
      setCheckingMyDispositions(false);
    }
  };

  return (
    <>
      <Tooltip content="Ver meus atendimentos" showArrow>
        <IconButton
          variant="ghost"
          color="argos.fg"
          onClick={checkMyDispositions}
          loading={checkingMyDispositions}
        >
          <HiOutlineClipboardDocumentList size={24} />
        </IconButton>
      </Tooltip>
      {showMyDispositionsDialog && myDispositions.length > 0 && (
        <MyDispositionsDialog
          executionId={executionId}
          list={myDispositions}
          handleClose={() => setShowMyDispositionsDialog(false)}
        />
      )}
    </>
  );
};

export default MyDispositionsButton;
